import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap';
import AddPhone from './AddPhone';
import { addMessagePolicy, editMessagePolicy } from '../../../actions/message-policy';
import { CardContainer, Heading5, Heading6, Icon, TitleIcon } from '../../widgets';

const MessageForm = ({ onHide, type, values }) => {
    const isAdd = type === 'add';
    const dispatch = useDispatch();
    const { farmId } = useParams();

    const policyList = useSelector(state => state.messagePolicy.list);
    const equipmentGroupList = useSelector(state => state.equipmentGroup.equipmentGroupList);

    const [crewList, setCrewList] = useState([]);
    const [phoneList, setPhoneList] = useState([]);
    const [isValid, setValid] = useState({ phone: true, crew: true });
    const [selectedCrewId, setSelectedCrewId] = useState([{ label: '', value: '' }]);
    const [messageAlert, setMessageAlert] = useState({
        load_approval_stopped: 1,
        resumed_harvester: 1,
        waiting_harvester: 1,
        load_approval_resumed: 1
    });

    const format = [{
        key: 'load_approval_stopped',
        label: 'Load Approval Stopped'
    },
    {
        key: 'load_approval_resumed',
        label: 'Load Approval Resumed'
    }, {
        key: 'waiting_harvester',
        label: 'Waiting Harvester'
    }, {
        key: 'resumed_harvester',
        label: 'Resumed Harvester'
    }];

    useEffect(() => {
        const key = 'crew_uuid';
        const list = equipmentGroupList.filter(e => e.crew.name !== '' && e.alive).map(e => e.crew);
        const crewList = [...new Map(list.map(item => [item[key], item])).values()];

        let arr = [];
        const entityIds = policyList && policyList.length > 0 ? policyList.map(e => e.entity_uuid) : [];

        for (const item of crewList) {
            if (!entityIds.includes(item.crew_uuid)) arr.push(item);
        }

        const crewOptions = [
            ...arr.map(e => ({
                value: e.crew_uuid,
                label: e.name
            }))
        ];

        setCrewList(crewOptions);
    }, []);

    useEffect(() => {
        if (values) {
            setSelectedCrewId(values.entity_name);
            const policies = values.policy_config;
            setMessageAlert({
                load_approval_stopped: policies.load_approval_stopped,
                load_approval_resumed: policies.load_approval_resumed,
                waiting_harvester: policies.waiting_harvester,
                resumed_harvester: policies.resumed_harvester
            });
        }
    }, [values]);

    const handleAdd = () => {
        let phoneArr = [];
        phoneList.forEach(e => {
            if (e.phone && e.phone.toString().trim().length !== 0) phoneArr.push(`${e.code}-${e.phone}`);
        });

        if (isAdd) {
            let entityArr = [];

            selectedCrewId.forEach(e => {
                if (e.value.toString().trim().length > 0) {
                    entityArr.push({
                        entity_uuid: e.value,
                        entity_type_id: 8,
                    });
                }
            });

            const params = {
                farm_uuid: farmId,
                entities: entityArr,
                phones: phoneArr,
                policy_config: messageAlert
            };

            if (phoneArr.length === 0 || entityArr.length === 0) setValid({ ...isValid, crew: entityArr.length > 0, phone: phoneArr.length > 0 });
            else {
                dispatch(addMessagePolicy(params));
                onHide(false);
            }
        }
        else {
            const params = {
                policy_id: values.policy_id,
                farm_uuid: farmId,
                entity_uuid: values.entity_uuid,
                entity_type_id: 8,
                phones: phoneArr,
                policy_config: messageAlert
            };

            if (phoneArr.length === 0) {
                setValid({ ...isValid, phone: false });
            }
            else {
                dispatch(editMessagePolicy(params));
                onHide(false);
            }
        }
    };

    return (
        <CardContainer className='form-container'>
            <Card className='card-form'>
                <Card.Header>
                    <Card.Title>
                        <Heading5>
                            <TitleIcon className={isAdd ? 'fa fa-exclamation-circle' : 'fa fa-pencil'} />{isAdd ? 'Add Configuration' : 'Edit Configuration'}
                        </Heading5>
                        <i className='fa fa-times close-btn' aria-hidden='true' title='close'
                            onClick={() => onHide(false)} />
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col className='col-12' style={{ zIndex: 999 }}>
                            <Form.Group>
                                <Heading6>Crew</Heading6>
                                {isAdd ? <Select
                                    style={{ zIndex: '999' }}
                                    className='select'
                                    isMulti
                                    closeMenuOnSelect={false}
                                    onChange={e => setSelectedCrewId(e)}
                                    options={crewList} /> :
                                    <Form.Control
                                        id='Crew'
                                        readOnly={true}
                                        placeholder='Select Crew'
                                        name='Crew'
                                        onChange={(e) => setSelectedCrewId(e && e.value ? e.value : null)}
                                        value={selectedCrewId}
                                        options={crewList}
                                    />
                                }
                                {!isValid.crew && <div className='mt-2' style={{ color: 'red' }}>This field is required</div>}
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className='mt-4 d-flex justify-content-evenly'>
                        <Col className='col-12'><Heading6>Configuration</Heading6></Col>

                        {format.map((e, index) => {
                            return (
                                <Col key={index} className='col-auto pr-0 my-2'>
                                    <Badge
                                        variant={messageAlert[e.key] ? 'success' : 'danger'}
                                        className={messageAlert[e.key] ? 'shadow-sm px-1' : 'px-1'}
                                        style={{ textTransform: 'capitalize', fontSize: '15px', marginBottom: '0px' }}
                                    >
                                        {/* {messageAlert[e.key] ? <i className="fa fa-check px-1" aria-hidden="true" /> : <></>} */}
                                        <label htmlFor={e.key}
                                            style={{ padding: '1px', cursor: 'pointer' }}
                                        >
                                            {e.label}
                                        </label>
                                        <input type={'checkbox'}
                                            id={e.key}
                                            style={{ display: 'none' }}
                                            name={e.key}
                                            checked={messageAlert[e.key]}
                                            onChange={(e) => setMessageAlert({ ...messageAlert, [e.target.name]: e.target.checked ? 1 : 0 })} />
                                    </Badge>
                                </Col>
                            );
                        })}
                    </Row>

                    <Row className='mt-3'>
                        <Col className='col-12'>
                            <Heading6>Phone</Heading6>
                            <AddPhone data={values} onChange={(e) => setPhoneList(e)} isValid={isValid.phone} />
                        </Col>
                    </Row>

                </Card.Body>
                <Card.Footer>
                    <Button
                        size='sm'
                        type='button'
                        variant='primary'
                        className='float-right ml-3'
                        onClick={() => handleAdd()}>
                        <Icon className='fa fa-floppy-o' /> Save
                    </Button>
                    <Button
                        size='sm'
                        type='button'
                        variant='danger'
                        className='float-right'
                        onClick={() => onHide(false)}>
                        <Icon className='fa fa-times-circle' /> Cancel
                    </Button>
                </Card.Footer>
            </Card>
        </CardContainer>
    );
};

export default MessageForm;